import request from "../utils/request.js"
// 获取地址列表
export function getAddressListApi(params) {
    return request({
        url: "/address/list",
        method: "post",
        data: params,
    })
}
// 删除地址
export function delAddressApi(params) {
    return request({
        url: "/address/delAddress/"+params,
        method: "get"
    })
}
// 添加地址
export function saveAddressApi(params) {
    return request({
        url: "/address/saveAddress",
        method: "post",
        data: params,
    })
}
